import type { IconData } from '@stacksjs/iconify-core'

export const healthMicroscope: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 10V7a4 4 0 0 1 4 4v1H0v4h16v-5a8 8 0 0 0-8-8a3 3 0 0 0-6 0v7z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default healthMicroscope
